import { getShippingEstimateQuantityInSeconds } from '@vtex/estimate-calculator'

import type { ProductSkuAvailabilityDelivery_ProductSkuOfferConnection$data } from './__generated__/ProductSkuAvailabilityDelivery_ProductSkuOfferConnection.graphql'

export const getBestDeliveryAvailabilities = (
  deliveryAvailabilities: ProductSkuAvailabilityDelivery_ProductSkuOfferConnection$data['edges'][number]['node']['deliveryAvailabilities']['edges']
) => {
  const cheapestDeliveryPrice = Math.min(
    ...deliveryAvailabilities.map(
      (deliveryAvailability) =>
        deliveryAvailability.node.netPrice.amount ?? Infinity
    )
  )

  const cheapestDeliverySlas = deliveryAvailabilities.filter(
    (sla) => sla.node.netPrice.amount === cheapestDeliveryPrice
  )

  const bestCheapestDeliverySla = cheapestDeliverySlas.reduce(
    (acc, current) => {
      const isFaster =
        getShippingEstimateQuantityInSeconds(current.node.shippingEstimate) <
        getShippingEstimateQuantityInSeconds(acc.node.shippingEstimate)

      return isFaster ? current : acc
    },
    cheapestDeliverySlas[0]
  )

  const fatestDeliveryValue = Math.min(
    ...deliveryAvailabilities.map((deliveryAvailability) =>
      getShippingEstimateQuantityInSeconds(
        deliveryAvailability.node.shippingEstimate
      )
    )
  )

  const fatestDeliverySlas = deliveryAvailabilities.filter(
    (deliveryAvailability) =>
      getShippingEstimateQuantityInSeconds(
        deliveryAvailability.node.shippingEstimate
      ) === fatestDeliveryValue
  )

  const bestFatestDeliverySla = fatestDeliverySlas.reduce((acc, current) => {
    const isCheaper = current.node.netPrice < acc.node.netPrice

    return isCheaper ? current : acc
  }, fatestDeliverySlas[0])

  return {
    cheapest: bestCheapestDeliverySla,
    fastest: bestFatestDeliverySla,
  }
}
